import { type useNavigate } from 'react-router-dom'

export const redirectIfNoRefreshToken = (navigate: ReturnType<typeof useNavigate>) => {
  const refreshToken = window.localStorage.getItem('refreshToken')
  if (!refreshToken) {
    navigate('/')
  }
}
